var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-group-container-wrapper"},[_c('div',{staticClass:"product-group-container"},[(_vm.filteredWardrobeProducts.length === 0)?_c('WardrobeEmptyState',{attrs:{"layer-display-name":_vm.layerDisplayName}}):_vm._l((_vm.filteredWardrobeProducts),function(wp){return _c('product',{key:wp.id,attrs:{"wardrobe-product":wp}})})],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb3ec8a0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/capsuleBuilder/modals/addProductModal/FromWardrobe.vue
// module id = 7AKZ
// module chunks = 0